import React from "react";

import * as S from "./SectionWithImage.Style";

const SectionWithImage = (props) => {
  return (
    <S.SectionContainer
      as={props?.as}
      $reverse={Boolean(props?.reverse)}
      $noContainer={Boolean(props.noContainer)}
      $noPadding={Boolean(props.noPadding)}
      className={props?.noContainer ? "" : "container"}
      style={props?.style}
    >
      <S.SectionImageContent>
        <S.SectionImage src={props.src} alt={props.alt} loading="lazy" />
      </S.SectionImageContent>
      <S.SectionBlockContent>{props.children}</S.SectionBlockContent>
    </S.SectionContainer>
  );
};

export default SectionWithImage;
